<template>
  <div class="bg-white">
    <div>
      <special-holiday-list
        :selected-index="selectedIndex"
      />
    </div>
  </div>
</template>

<script>
import SpecialHolidayList from './lists.vue';
export default {
  name: 'SpecialHolidays',
  components: {
    SpecialHolidayList,
  },
  props: {
    selectedIndex: {
      type: Number,
      default: null,
    },
  },
};
</script>
